import { useEffect } from "react";
import { Link } from "react-router-dom";

import { Header } from "../../components/header";
import { analyticsService } from "../../services/firebase-service";

export const DiagnosticoInicialEmBreve = () => {
  useEffect(() => {
    analyticsService.event("page-participar-comunidade-em-breve");
  }, []);

  return (
    <main className="container">
      <Header />
      <div className="header">
        <h2 className="h5 my-5">
          🏢 Recebemos as informações
          <br /> da sua empresa!
        </h2>
        <p className="mb-4" style={{ maxWidth: 350 }}>
          Em breve você receberá no seu e-mail o relatório de diagnóstico da sua empresa.
        </p>
        <p>
          <Link to="/">Ir para página inicial</Link>
        </p>
      </div>
    </main>
  );
};
